@use "~theme/typography";
@use "~theme/breakpoints";
.wearOption {
  height: 90px;
  width: 328px;
  border-radius: 8px;
  border: 1px solid var(--white);
  background-color: var(--white);
  outline: none;
  filter: drop-shadow(0 1px 3px rgb(0 0 0 / 8%));
  cursor:pointer;
}

// .wearOption:hover {
//   border-color: var(--blue-01-at-30);
// }

// .wearOption:active {
//   filter: drop-shadow(0 2px 6px var(--highlight-blue));
//   border-color: var(--white);
// }

// .wearOption:focus-within {
//   filter: drop-shadow(0 2px 6px var(--highlight-blue));
// }

.wearOptionNameContainer {
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  float: left;
  width:60%;
}

.addMargin {    
  margin: 5px 0px;
}

.wearOptionName {
  @include typography.heading6;
  margin: auto;
  text-align: center;
}

.radio{
    float: left;
    width:10%;
    margin: 25px 5px;
}

.icon{
    float: left;
    width:20%;
    margin: 5px 0px;
    margin-right: 14px;
    border: 3px solid var(--border-blue);
    border-radius: 4px;
}


.wearOptionMobile {
  background: var(--white);
  box-shadow: 0px 1px 4px rgb(0 0 0 / 8%);
  border-radius: 8px;
  width: 147px;
  height: 120px;
  cursor:pointer;
  text-transform: capitalize;
  @include breakpoints.desktop {
    text-transform: uppercase;
  }

  .wearOptionNameContainer {
    width: 100%;
    float: none;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .addMargin {    
    margin: 0px;
    padding: 0px;
  }
  .addMarginIcon {    
    margin-bottom: 0px;
  }
  
  .wearOptionName {
    font-weight: 600;
    font-size: 12px;
    line-height: 140%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    letter-spacing: 0.02em;
    color: var(--black);
    text-transform: capitalize;
    @include breakpoints.desktop {
      text-transform: uppercase;
    }
  }

  .icon{
    width: 53px;
    float: none;
    margin: 5px 0px;
    margin-right: 0;
    border: 3px solid var(--border-blue);
    border-radius: 4px;
  }
}

.selected {
  border: 4px solid var(--highlight-blue);
  box-shadow: 0px 1px 4px rgb(0 0 0 / 8%);
}
